import CandidateSearch from './CandidateSearch.container';

export default CandidateSearch;
